import { useState, FormEvent } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    category: 'audition',
    sns: '',
    birthday: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('category', formData.category);
      formBody.append('sns', formData.sns);
      formBody.append('birthday', formData.birthday);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d671ufcfomltbg1qamjg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          category: 'audition',
          sns: '',
          birthday: '',
          message: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="absolute top-0 left-0 w-96 h-96 bg-pink-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block bg-gradient-to-r from-pink-500/20 to-cyan-500/20 rounded-full px-6 py-2 mb-6">
              <span className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400">CONTACT</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
              あなたの
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400">夢</span>を
              <br />
              聞かせてください
            </h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              VTuberとしてデビューしたい方、お仕事のご依頼、その他お問い合わせなど、お気軽にご連絡ください。
            </p>
            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 rounded-xl">
                  <i className="ri-mail-fill text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-400">メール</p>
                  <p className="text-white font-medium">stellarlive.20260118@gmail.com</p>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 rounded-xl">
                  <i className="ri-twitter-x-fill text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-400">Twitter</p>
                  <p className="text-white font-medium">@stellarlive_</p>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 rounded-xl">
                  <i className="ri-instagram-fill text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-400">Instagram</p>
                  <p className="text-white font-medium">@stellarlive_official</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">
              お問い合わせフォーム
            </h3>
            <p className="text-sm text-gray-600 mb-6 text-center">
              必要事項をご記入の上、送信してください
            </p>

            <form id="contact_form" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label htmlFor="category" className="block text-sm font-semibold text-gray-900 mb-2">
                  お問い合わせ種別 <span className="text-pink-500">*</span>
                </label>
                <select
                  id="category"
                  name="category"
                  required
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent cursor-pointer"
                >
                  <option value="audition">オーディション応募</option>
                  <option value="business">お仕事のご依頼</option>
                  <option value="fanmail">ファンレター</option>
                  <option value="other">その他</option>
                </select>
              </div>

              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-2">
                  お名前 <span className="text-pink-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                  placeholder="山田 太郎"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
                  メールアドレス <span className="text-pink-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                  placeholder="example@email.com"
                />
              </div>

              <div>
                <label htmlFor="sns" className="block text-sm font-semibold text-gray-900 mb-2">
                  SNSアカウント（任意）
                </label>
                <input
                  type="text"
                  id="sns"
                  name="sns"
                  value={formData.sns}
                  onChange={(e) => setFormData({ ...formData, sns: e.target.value })}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                  placeholder="@username"
                />
              </div>

              <div>
                <label htmlFor="birthday" className="block text-sm font-semibold text-gray-900 mb-2">
                  生年月日 <span className="text-pink-500">*</span>
                </label>
                <input
                  type="date"
                  id="birthday"
                  name="birthday"
                  required
                  value={formData.birthday}
                  onChange={(e) => setFormData({ ...formData, birthday: e.target.value })}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent cursor-pointer"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-gray-900 mb-2">
                  メッセージ <span className="text-pink-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent resize-none"
                  placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500文字</p>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                  <p className="text-sm text-green-800 text-center">
                    送信完了しました！担当者より折り返しご連絡いたします。
                  </p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 rounded-xl p-4">
                  <p className="text-sm text-red-800 text-center">
                    送信に失敗しました。もう一度お試しください。
                  </p>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-8 py-4 bg-gradient-to-r from-pink-500 to-cyan-500 text-white text-sm font-bold rounded-full hover:opacity-90 transition-opacity inline-flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span>{isSubmitting ? '送信中...' : '送信する'}</span>
                <i className="ri-send-plane-fill text-lg"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
